module.exports = __webpack_public_path__ + "static/media/Cats eyes 10_SVENSKA-mixdown.9cca07c7.mp3";